import { combineReducers } from '@reduxjs/toolkit';
import merchantReducer from '../modules/merchantSelector/merchantSelectorSlice';
var rootReducer = combineReducers({
    merchantSelector: merchantReducer,
});
export default rootReducer;
//# sourceMappingURL=rootReducer.js.map